<template>
  <div>
    <p class="body-1 grey--text text--darken-1 mt-4">{{ $t('label.workflowHistory')}}</p>
    <v-data-table :items="items" hide-actions class="elevation-1" :no-data-text="$t('message.warning.noDataWorkflowHistory')" :pagination.sync="pagination" :rows-per-page-items="rowsPerPageItems" id="workflowHistory">
      <template slot="headers" slot-scope="props">
        <tr>
          <th class="dateTime">{{ $t('label.date') }}</th>
          <th class="person-name">{{ $t('label.person') }}</th>
          <th>{{ $t('label.comments') }}</th>
          <th class="file-download">{{ $t('label.files') }}</th>
          <th class="event-type">{{ $t('label.approved') }}?</th>
        </tr>
      </template>
      <template slot="items" slot-scope="props">
        <app-workflow-item :item="props.item" @click.native="toggleDetail(props.item)"></app-workflow-item>
      </template>
    </v-data-table>

    <div id="detail">
      <app-workflow-item-detail v-if="isDetailing" :item="detail"></app-workflow-item-detail>
    </div>
  </div>
</template>

<script>
import zenscroll from 'zenscroll';
import constants from '@/helpers/constants';
// import utilities from '@/helpers/utilities';
import Files from '../../shared/Files';
import WorkflowItem from './WorkflowItem';
import WorkflowItemDetail from './WorkflowItemDetail';


export default {
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            constants,
            rowsPerPageItems: constants.componentOptions.rowsPerPageItems,
            pagination: {
                descending: false,
                sortBy: 'dateApproved',
            },

            isDetailing: false,
            detail: {},
        };
    },
    watch: {
        items: 'hideDetail',
    },
    methods: {
        toggleDetail(detail) {
            // if (!utilities.isApprovalOrRejectionStatus(detail.status.id)) return;

            if (this.detail !== null && this.detail.id === detail.id) {
                this.hideDetail();
                return;
            }
            this.showDetail(detail);
        },
        showDetail(detail) {
            this.detail = detail;
            this.isDetailing = true;
            zenscroll.to(document.getElementById('detail'), 0);
        },
        hideDetail() {
            this.isDetailing = false;
            this.detail = null;
        },
    },
    components: {
        appFiles: Files,
        appWorkflowItem: WorkflowItem,
        appWorkflowItemDetail: WorkflowItemDetail,
    },
};
</script>




// WEBPACK FOOTER //
// src/components/demands/shared/WorkflowHistory.vue